import proxyPolyfillFunc from 'proxy-polyfill/proxy.min.js';

function usePortal(name, cb){
	const handler = {
		get: function (obj, prop, receiver) {
			if (name && prop === name) {
				return obj[prop]
			}
			return Reflect.get(...arguments);
		},
		set: function (obj, prop, value, receiver) {
			try{
				if (name && prop === name) {
					obj[prop] = value
					cb(value)
					return true;
				}
			} catch (err) {
				console.error(err);
			}
			return Reflect.set(...arguments);
		},
	};

	if (window.Proxy) {
		ReactPortal = new Proxy(ReactPortal,
			handler);
	} else {
		const ProxyPolyfill = proxyPolyfillFunc();
		ReactPortal = new ProxyPolyfill(ReactPortal,
			handler);
	}

}

export default usePortal;
